<template>
  <div
    v-if="typeof price === 'number' || isPriceTelemedMedtochkaVisible"
    :data-appointment-type-redirect="redirectValue"
    data-qa="doctor_price_block"
  >
    <PriceFreeByCondition
      v-if="isPriceFreeVisible"
      :price="price"
    />
    <PriceWithClub
      v-else-if="isPriceClubVisible"
      :club-price="clubPrice"
      :price="price"
      @click:show-info="handleClickShowClubInfoModal"
    />
    <PriceClinic
      v-else-if="isPriceClinicVisible"
      :price="price"
    />
    <PriceTelemed
      v-else-if="isPriceTelemedMedtochkaVisible"
      :price="telemedMedtochkaPrice"
      :speciality-selected="specialitySelected"
    />
    <PriceTelemed
      v-else-if="isPriceTelemedVisible"
      :price="price"
      :speciality-selected="specialitySelected"
    />
    <PriceHome
      v-else-if="isPriceHomeVisible"
      :price="price"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'
import { REDIRECT_VALUES } from 'www/constants'
import PriceFreeByCondition from 'www/vue_components/common/DoctorPriceBlockV2/components/PriceFreeByCondition.vue'
import PriceWithClub from 'www/vue_components/common/DoctorPriceBlockV2/components/PriceWithClub.vue'
import PriceClinic from 'www/vue_components/common/DoctorPriceBlockV2/components/PriceClinic.vue'
import PriceTelemed from 'www/vue_components/common/DoctorPriceBlockV2/components/PriceTelemed.vue'
import PriceHome from 'www/vue_components/common/DoctorPriceBlockV2/components/PriceHome.vue'
import dispatchCustomEventGlobally from 'www/utils/withDependences/dispatchCustomEventGlobally'

const props = defineProps<{
  pageType: 'clinic' | 'telemed' | 'home'
  price?: number | null
  clubPrice?: number | null
  telemedMedtochkaPrice?: number | null
  tabIsFreeWithTreatment?: boolean
  specialitySelected?: boolean
}>()

const clubOfferData = computed(() => {
  if (typeof props.clubPrice !== 'number') {
    return {}
  }

  const couponPrice = Math.floor(props.clubPrice / 2)
  const cardPrice = window.USER.club.isInClub ? 0 : window.USER.club.cardNextPrice

  return {
    lpuPrice: props.clubPrice - couponPrice,
    couponPrice,
    cardDateEnd: window.USER.club.cardDateEnd,
    cardPrice,
    totalPrice: props.clubPrice + (cardPrice || 0),
  }
})

const handleClickShowClubInfoModal = () => {
  dispatchCustomEventGlobally('club-discount-info-bottom-sheet:open', {
    fullPrice: props.price,
    clubOfferData: clubOfferData.value,
  })
}

const isPriceFreeVisible = computed(() => props.tabIsFreeWithTreatment && props.pageType === 'clinic')
const isPriceClubVisible = computed(() => typeof props.clubPrice === 'number' && props.pageType === 'clinic')
const isPriceClinicVisible = computed(() => typeof props.price === 'number' && props.pageType === 'clinic')
const isPriceTelemedVisible = computed(() => typeof props.price === 'number' && props.pageType === 'telemed')
const isPriceTelemedMedtochkaVisible = computed(() => (
  props.pageType === 'telemed'
  && typeof props.price !== 'number'
  && typeof props.telemedMedtochkaPrice === 'number'
))
const isPriceHomeVisible = computed(() => typeof props.price === 'number' && props.pageType === 'home')

const redirectValue = computed<typeof REDIRECT_VALUES[keyof typeof REDIRECT_VALUES]>(() => {
  if (isPriceClubVisible.value) {
    return REDIRECT_VALUES.club
  }

  if (props.pageType === 'clinic') {
    return REDIRECT_VALUES.default
  }

  if (isPriceTelemedMedtochkaVisible.value) {
    return REDIRECT_VALUES.telemedMedtochka
  }

  return REDIRECT_VALUES[props.pageType]
})

const emit = defineEmits(['update:redirect-value'])

watch(redirectValue, () => {
  emit('update:redirect-value', redirectValue.value)
}, { immediate: true })
</script>
